import { render, staticRenderFns } from "./TeusHistoricos.vue?vue&type=template&id=2087efda"
import script from "./TeusHistoricos.vue?vue&type=script&lang=js"
export * from "./TeusHistoricos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports